import React from 'react'
import MarketoForm from '../../../components/MarketoForm'
import './styles.scss'

import horizontalLogo from '../../../images/logos/LaunchDarkly_Horizontal_Primary_Logo_on_Light_RGB.svg'

const Form = ({ formTitle, formSubtitle, marketoFormId }) => (
  <div className="form-content">
    <div className="section">
      <div className="container">
        <div className="is-flex">
          <img
            className="form-image"
            src={horizontalLogo}
            alt="launchdarkly logo of rocketship and text"
            loading="lazy"
          />
        </div>
        <h2 className="title title-black">{formTitle}</h2>
        {formSubtitle && <p className="form-subtitle">{formSubtitle}</p>}
        <br />
        <MarketoForm formId={marketoFormId} />
        <br />
        <p className="help">
          By submitting you agree to LaunchDarkly's{' '}
          <a href="/policies/terms-of-service/" target="_blank" rel="noopener noreferrer">
            Terms
          </a>{' '}
          and{' '}
          <a href="/policies/privacy/" target="_blank" rel="noopener noreferrer">
            Privacy Policies
          </a>
          .
        </p>
      </div>
    </div>
  </div>
)

export default Form
